import React from 'react';

// Easily maintainable logo list: add/remove entries below.
// image: path inside public/ (e.g. /partners/logo-x.png)
// title: alt text & tooltip
// href: optional external or internal link (omit for no link)
const LOGOS = [
  { image: '/partners/dantronik-logo.png', title: 'Dantronik GmbH', href: 'https://dantronik.de/' },
  { image: '/partners/fotokram_nord-logo.png', title: 'Fotokram-Nord', href: 'https://fotokram-nord.de/' },
  { image: '/partners/reesling_logo.png', title: 'Reesling-Vital', href: 'https://reesling-vital.de/' },
  { image: '/partners/sora-media-logo.png', title: 'Sora-Media', href: 'https://www.sora-media.de/' },
  { image: '/partners/streamvibes-logo.png', title: 'StreamVibes', href: 'https://streamvibes.de/' },
  { image: '/partners/gz-tattoo-logo.jpg', title: 'GZ Tattoo Atelier', href: 'https://www.instagram.com/gz_tattooatelier/?hl=de' },
  { image: '/partners/tauchermuseum-flensburg-logo.png', title: 'Tauchermuseum-Flensburg e.V.', href: 'https://tauchermuseum-flensburg.de/' },
  { image: '/partners/wif-logo.jpg', title: 'Wir in Flensburg', href: 'https://www.facebook.com/groups/wifflensburg/?locale=de_DE' }
];

export default function PartnerLogoCarousel({ logos = LOGOS, height = 60, gap = 48, speedSeconds = 30 }) {
  if (!Array.isArray(logos) || logos.length === 0) return null;
  // Duplicate list for seamless infinite scroll
  const doubled = [...logos, ...logos];
  return (
    <div className="partner-logo-carousel" aria-label="Partner Logos" style={{
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
      padding: '18px 0',
      background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.02))',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 14,
      backdropFilter: 'blur(4px)'
    }}>
      <div style={{
        position: 'absolute', left: 0, top: 0, height: '100%', width: '100%',
        pointerEvents: 'none',
        background: 'linear-gradient(90deg, #0d1320 0%, rgba(13,19,32,0) 8%, rgba(13,19,32,0) 92%, #0d1320 100%)'
      }} />
      <div className="plc-track" style={{
        display: 'flex',
        alignItems: 'center',
        gap: gap,
        width: 'fit-content',
        animation: `plc-scroll ${speedSeconds}s linear infinite`
      }}>
        {doubled.map((l, i) => {
          const content = (
            <img
              src={l.image}
              alt={l.title}
              title={l.title}
              style={{
                height: height,
                width: 'auto',
                objectFit: 'contain',
                filter: 'grayscale(100%) brightness(1.15)',
                opacity: 0.9,
                transition: 'filter 220ms, opacity 220ms, transform 220ms'
              }}
              loading="lazy"
            />
          );
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: height * 2 }}>
              {l.href ? (
                <a
                  href={l.href}
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  onMouseEnter={e => {
                    const img = e.currentTarget.querySelector('img');
                    if (img) {
                      img.style.filter = 'grayscale(0%) brightness(1.05)';
                      img.style.opacity = '1';
                      img.style.transform = 'scale(1.04)';
                    }
                  }}
                  onMouseLeave={e => {
                    const img = e.currentTarget.querySelector('img');
                    if (img) {
                      img.style.filter = 'grayscale(100%) brightness(1.15)';
                      img.style.opacity = '0.9';
                      img.style.transform = 'none';
                    }
                  }}
                >
                  {content}
                </a>
              ) : content}
            </div>
          );
        })}
      </div>
      <style>{`
        @keyframes plc-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .partner-logo-carousel:hover .plc-track { animation-play-state: paused; }
        @media (max-width: 700px) {
          .partner-logo-carousel { padding: 14px 0; }
        }
      `}</style>
    </div>
  );
}

// Usage:
// <PartnerLogoCarousel /> inside a section. To customize logos:
// <PartnerLogoCarousel logos={[{ image:'/partners/new.png', title:'Neuer Partner', href:'https://..' }]} />